// extracted by mini-css-extract-plugin
module.exports = {"button-group":"code-block-action-button-group_button-group__QsOaL","dropdown":"code-block-action-button-group_dropdown__tlBqw"};